import React, { useCallback, useEffect, useState } from 'react'
import { injectIntl } from 'react-intl'
import IconBack from '@material-ui/icons/ArrowBack'
import { IconButton } from '@material-ui/core'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { debounce } from 'lodash'
import {
  fetchTriggerTableData,
  setTablePsfs,
} from 'reducers/jobsTriggers/reducer'
import Psfs from 'lib/psfs/Psfs'
import usePrevious from 'hooks/usePrevious'
import { StyledButton } from 'components/common/Modals/styles'
import { Flex } from 'components/common/styles'
import messages from './translate'
import { StyledHeader, StyledSearchField, StyledTitle } from './styles'

function JobsTriggersHeader({
  intl: { formatMessage },
  history: { goBack },
  setIsModalOpened,
  tablePsfs,
  setTablePsfs,
  fetchTriggerTableData,
  featureFlags,
}) {
  const fetchData = psfs => {
    fetchTriggerTableData({ psfs })
  }

  const [searchValue, setSearchValue] = useState('')
  const prevSearchValue = usePrevious(searchValue)

  const fetchDataDebounced = useCallback(debounce(fetchData, 1000), [])

  useEffect(() => {
    if (searchValue !== prevSearchValue && prevSearchValue !== undefined) {
      const { path } = tablePsfs
      const psfs = new Psfs(path)

      psfs.addSearch(searchValue)

      setTablePsfs(psfs)
      fetchDataDebounced(psfs)
    }
  }, [searchValue])

  return (
    <StyledHeader
      className="jobs-triggers-header"
      justify="space-between"
      align="center"
      isNewHeader={featureFlags.APP_HEADER_V2}>
      <Flex>
        <StyledTitle>
          <IconButton size="medium" className="btn-back" onClick={goBack}>
            <IconBack fontSize="small" />
          </IconButton>
          {formatMessage(messages.jobsTriggersAppName)}
        </StyledTitle>
        <Flex align="center">
          <StyledSearchField
            placeholder={formatMessage(messages.searchByRuleName)}
            onChange={({ target: { value } }) => setSearchValue(value)}
            value={searchValue}
            disableUnderline
          />
        </Flex>
      </Flex>
      <StyledButton
        type="button"
        className="primary"
        onClick={() => {
          setIsModalOpened(true)
        }}>
        {formatMessage(messages.addTriggerRule)}
      </StyledButton>
    </StyledHeader>
  )
}

export default connect(
  state => ({
    tablePsfs: state.getIn(['jobsTriggers', 'tablePsfs']),
    isLoading: state.getIn(['jobsTriggers', 'isLoading']),
    featureFlags: state.getIn(['profile', 'profile', 'featureFlags']),
  }),
  {
    fetchTriggerTableData,
    setTablePsfs,
  },
)(withRouter(injectIntl(JobsTriggersHeader)))
